export enum EBaseApiTags {
	CONFIG = 'CONFIG',
	NOTIFICATIONS_COUNT = 'NotificationsCount',
	NOTIFICATIONS_LIST = 'NotificationsList',
	PROFILE = 'Profile',
	PORTFOLIO = 'PORTFOLIO',
	TASKS = 'TASKS',
	TASK = 'TASK',
	CLIENT_TASKS = 'CLIENT_TASKS',
	CLIENT_TASK = 'CLIENT_TASK',
	CLIENT_OFFERS = 'CLIENT_OFFERS',
	CLIENT_OFFER = 'CLIENT_OFFER',
	CONTRACTOR_TASKS = 'CONTRACTOR_TASKS',
	CONTRACTOR_TASK = 'CONTRACTOR_TASK',
	TIMELINE = 'TIMELINE',
	OFFERS = 'OFFERS',
	OFFER = 'OFFER',
	TRANSACTION_LIST = 'TransactionList',
	TRANSACTION = 'Transaction',
}
